import styled from "styled-components";

const StyledConfigShirtWrap = styled.div`
  position: relative;
  padding: 160px 64px 0;
  @media screen and (max-width: 1439px){
    padding: 140px 40px 0;
  }
  @media screen and (max-width: 1023px){
    padding: 100px 20px 0;
  }
  h4 {
    text-align: center;
    margin-bottom: 80px;
  }
  
`

const StyledConfigShirtCols = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  @media screen and (max-width: 1023px) {
    flex-direction: column;
  }
  .blue {
    color: #152459;
  }
  iframe {
    position: absolute;
    width: 50%;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    border: none;
    height: 100%;
    @media screen and (max-width: 1023px) {
      position: relative;
      width: 80%;
      height: 50vh;
    }
  }
  .col-config{
    position: relative;
    flex: 1 1 25%;
    max-width: 25%;
    
    @media screen and (max-width: 1023px) {
      flex: 0 0 80%;
      max-width: 80%;
      margin: 40px auto;
    }
    .col-row-text {
      position: relative;
      width: 100%;
      display: flex;
      margin-bottom: 10px;
      text-align: left;
      padding: 0 15px;
      @media screen and (max-width: 1023px) {
        padding: 0;
      }
      img {
        width: 100%;
        display: block;
        max-width: 250px;
      }
    }
  }
  .col-buttons {
    color: #152459;
  }
  .row-config {
    position: relative;
    width: 100%;
    margin-bottom: 24px;
    p {
      margin-bottom: 18px;
    }
    .icons-row {
      position: relative;
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
    }
    .icon-wrap {
      padding: 10px;
      text-align: center;
      width: 80px;
      &.selected {
        background-color: #eaeefb;
      }
      img {
        width: 50px;
        margin: 0 auto;
      }
      p {
        margin: 0 auto;
        font-size: 12px;
        white-space: nowrap;
      }
    }
  }
  .col-config-mobile {
    position: relative;
    width: 100%;
    overflow: hidden;
    margin-top: 20px;
  }
  .col-config-slide {
    position: relative;
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    transform: translateX(0);
    transition: transform 0.5s ease-in-out;
  }
  .row-config-mobile {
    position: relative;
    width: 100%;
    text-align: center;
    flex: 0 0 100%;
    p {
      margin: 10px auto;
    }
    .icons-row{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .icon-wrap {
        padding: 10px;
        text-align: center;
        width: 80px;
        margin: 0 10px;
        &.selected {
          background-color: #eaeefb;
        }
        img {
          width: 50px;
          margin: 0 auto;
        }
      }
    }
  }

  .arrow-config {
    position: absolute;
    z-index: 3;
    background-color: #fff;
    width: 40px;
    height: 100%;
    display: flex;
    align-items: center;
    top: 0;
    opacity: 1;
    transition: opacity .25s;
    &.disable{
      opacity: 0;
    }
    img {
      display: block;
      width: 100%;
      margin-top: 25px;
    }
    &.arrow-prev {
      left: 0;
      padding-left: 10px;
    }
    &.arrow-next {
      right: 0;
      padding-right: 10px;
    }
  }
`;

const StyledConfigShirtRow = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin: 80px auto;
  img {
    display: block;
  }
  img.wash {
    flex: 1 1 33%;
    max-width: 33%;
  }
  img.rewiews {
    flex: 1 1 24%;
    max-width: 24%;
  }
  img.stars {
    flex: 1 1 41%;
    max-width: 41%;
  }
  @media screen and (max-width: 1023px) {
    display: none;
  }
  }
`;

export{
  StyledConfigShirtWrap,
  StyledConfigShirtCols,
  StyledConfigShirtRow
}